import React from "react";
import { Flex, Spin } from "antd";
import type { Property } from "csstype";

type cssHeight = Property.Height | undefined;

export default function LoadingScreen(props: { height?: cssHeight }) {
    const { height } = props;
    return (
        <Flex justify="center" align="center" style={{ height: height || "100vh" }}>
            <Flex>
                <Spin size="large" />
            </Flex>
        </Flex>
    );
}
